import { WorkIcon } from 'pages/candidateOfferList/img';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

import OfferAdditionalAction from './OfferAdditionalAction';

export default function NavigateActionAskForOpportunities() {
    const { t } = useTranslation('candidateOffers');
    const navigate = useNavigate();
    const { search } = useLocation();

    const handleClick = useCallback(() => {
        navigate({
            pathname: APP_ROUTES.requestForOpportunities,
            search
        });
    }, [ navigate, search ]);

    return <OfferAdditionalAction
        icon={ <WorkIcon /> }
        iconColor="#D01C53"
        text={ t('additionalActions.askForOpportunities') }
        description={ t('additionalActions.askForOpportunitiesDescription') }
        onClick={ handleClick }
    />;
}
